import { render, staticRenderFns } from "./TopPosters.vue?vue&type=template&id=38669d3e&"
import script from "./TopPosters.vue?vue&type=script&lang=js&"
export * from "./TopPosters.vue?vue&type=script&lang=js&"
import style0 from "./TopPosters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports